import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserSessionResponse } from '../../shared/types/user.types';
import { ApiResponse } from '../../shared/types/invitation-api.types';
import { environment } from '../../../environments/environment';

export interface TermsVersionResponse {
  version: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserSessionService {
  private readonly API_BASE_URL = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // Obtiene la sesión del usuario actual
  getUserSession(): Observable<ApiResponse<UserSessionResponse>> {
    return this.http.get<ApiResponse<UserSessionResponse>>(`${this.API_BASE_URL}/auth/user-session`);
  }

  /** Obtiene la versión actual de términos y condiciones*/
  getCurrentTermsVersion(): Observable<ApiResponse<TermsVersionResponse>> {
    return this.http.get<ApiResponse<TermsVersionResponse>>(`${this.API_BASE_URL}/general-config/terms-conditions/current-version`);
  }

  /** Acepta términos y condiciones*/
  acceptTerms(version?: string): Observable<ApiResponse<string>> {
    const body = version != null ? { version } : {};
    return this.http.post<ApiResponse<string>>(`${this.API_BASE_URL}/user/terms-conditions`, body );
  }
}